import React from "react";
import { Button } from "@material-ui/core";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import TierForm from "./tier-form";

const TiersInformations = props => {
  const { t } = useTranslation();

  return (
    <div>
      <h4>{t("add_kid.tiers_info.title")}</h4>

      {[...Array(props.values.tierceAutorisesDto.length)].map((item, index) => (
        <TierForm key={index} {...props} index={index} />
      ))}
      <Button color="primary" onClick={props.handleAddTier}>
        {t("add_kid.tiers_info.add_tier")}
      </Button>
    </div>
  );
};

TiersInformations.propTypes = {
  values: PropTypes.object,
  handleAddTier: PropTypes.func
};

export default TiersInformations;
